import { NgModule } from '@angular/core';
import { OutreachService } from './services/outreach.service';
import { TemplatesService } from './services/templates.service';

@NgModule({
  providers: [TemplatesService, OutreachService],
})
export class SolicitationModule {}
